import { useContext } from 'react';
import { HoldingTableContext, IHoldingTableContext } from './HoldingTableContext';

export const useClientDetailsTable = () => useContext<IHoldingTableContext>(HoldingTableContext);
